import { render, staticRenderFns } from "./BrandBuyerBox.vue?vue&type=template&id=1bf6275e"
import script from "./BrandBuyerBox.vue?vue&type=script&lang=js"
export * from "./BrandBuyerBox.vue?vue&type=script&lang=js"
import style0 from "./BrandBuyerBox.vue?vue&type=style&index=0&id=1bf6275e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports